export const FR_VAT_RATES = [
  { value: 20, label: '20 %' },
  { value: 10, label: '10 %' },
  { value: 5.5, label: '5,5 %' },
  { value: 2.1, label: '2,1 %' },
];

export function normalizeFrenchVatRate(rate) {
  const n = Number(rate);
  if (!Number.isFinite(n)) return 10;
  for (const r of FR_VAT_RATES) {
    if (Math.abs(n - r.value) < 0.001) return r.value;
  }
  return 10;
}

export function priceTtcFromHt(priceHt, vatRate) {
  const ht = Math.max(0, Number(priceHt) || 0);
  const vat = normalizeFrenchVatRate(vatRate);
  return Math.round(ht * (1 + vat / 100) * 100) / 100;
}

export function priceHtFromTtc(priceTtc, vatRate) {
  const ttc = Math.max(0, Number(priceTtc) || 0);
  const vat = normalizeFrenchVatRate(vatRate);
  if (ttc === 0) return 0;
  return Math.round((ttc / (1 + vat / 100)) * 100) / 100;
}

export function normalizeClickCollectItemPricing(raw = {}) {
  const vatRate = normalizeFrenchVatRate(raw.vatRate ?? 10);
  let priceHt = Number(raw.priceHt);
  if (!Number.isFinite(priceHt) || priceHt < 0) {
    priceHt = priceHtFromTtc(raw.priceTtc, vatRate);
  }
  priceHt = Math.max(0, Math.round(priceHt * 100) / 100);
  const priceTtc = priceTtcFromHt(priceHt, vatRate);
  return { priceHt, vatRate, priceTtc };
}

export const DEFAULT_CLICK_COLLECT_PAYMENT = {
  enabled: false,
  stancerPublicKey: '',
  stancerPrivateKey: '',
  stancerPublicKeyConfigured: false,
  stancerPrivateKeyConfigured: false,
  stancerKeysConfigured: false,
};

export function normalizeClickCollectPayment(raw) {
  const o = raw && typeof raw === 'object' ? raw : {};
  return {
    enabled: o.enabled === true,
    stancerPublicKey: '',
    stancerPrivateKey: '',
    stancerPublicKeyConfigured: o.stancerPublicKeyConfigured === true,
    stancerPrivateKeyConfigured: o.stancerPrivateKeyConfigured === true,
    stancerKeysConfigured: o.stancerKeysConfigured === true,
  };
}

/** Payload API : n’envoie les clés que si l’utilisateur vient de les saisir. */
export function serializeClickCollectPaymentForSave(payment) {
  const p = payment && typeof payment === 'object' ? payment : {};
  const out = { enabled: p.enabled === true };
  if (String(p.stancerPublicKey || '').trim()) {
    out.stancerPublicKey = String(p.stancerPublicKey).trim();
  }
  if (String(p.stancerPrivateKey || '').trim()) {
    out.stancerPrivateKey = String(p.stancerPrivateKey).trim();
  }
  return out;
}
